require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-loipersdorf-kitzladen.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-loipersdorf-kitzladen");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-loipersdorf-kitzladen!./.cache/json/betreuungseinrichtungen-oberwart-loipersdorf-kitzladen.json
// module id = 1011
// module chunks = 231608221292675